<template>
  <div v-if="isVisible" class="dropdown-menu">
    <ul>
      <li @click="sortSkills('Alphabetisch')">Alphabetisch</li>
      <li @click="sortSkills('Absteigend')">Absteigend</li>
      <li @click="sortSkills('Aufsteigend')">Aufsteigend</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    sortSkills(criteria) {
      this.$emit('sort', criteria);
      'this.isVisible = false; // Hide dropdown after selection'
      console.log("2")
    },
  },
};
</script>

<style scoped>
.dropdown-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}
.dropdown-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dropdown-menu li {
  padding: 8px 12px;
  cursor: pointer;
}
.dropdown-menu li:hover {
  background-color: #f0f0f0;
}
</style>
